import Vue from 'vue/dist/vue.esm'
import VeeValidate, { Validator } from 'vee-validate'
import i18n from '@/i18n'

import './falsy'
import './file_ext'
import './truly'
import './name'

Vue.use(VeeValidate, { 
  classes: true 
})

const dictionary = {
  en: {
    messages: {
      required: () => i18n.t('f_v_required'),
      email: () => i18n.t('f_v_email'),
      confirmed: () => i18n.t('f_v_email_confirmation'),
      min_value: () => i18n.t('f_v_required'),
      decimal: () => i18n.t('f_v_required'),
      truly: () => i18n.t('f_v_signseal_required'),
      full_name: () => i18n.t('f_v_required')
    },
    custom: {
      phoneValid: {
        truly: () => i18n.t('f_v_invalid_phone_number')
      }
    }
  }
}

// Override and merge the dictionaries
Validator.localize(dictionary)
